import { SummaryType } from '@ls/grouping-service';
import { produce } from 'immer';
import { deleteDefinition } from 'state/grid/util';
import { COMMIT_SELECTIONS } from 'state/selections/actions';
import SelectionState from 'state/selections/SelectionState';
import {
  RECEIVE_GRID_DATA, REQUEST_GRID_DATA, SET_DEFINITION, SET_DEFINITIONS, DELETE_DEFINITION, RECEIVE_ANALYTICS_SBS_DATA,
  REQUEST_ANALYTICS_SBS_DATA
} from './actions';

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },
  fetchingData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  data: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
  fetchingTESbsData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  trackingSbsData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
  options: [
    {
      label: 'TOTAL',
      value: 'TOTAL',
    },
    {
      label: 'LOCAL',
      value: 'LOCAL',
    },
    {
      label: 'EXCESS',
      value: 'EXCESS',
    },
    {
      label: 'CURRENCY',
      value: 'CURRENCY',
    },
    {
      label: 'SPECIFIC',
      value: 'SPECIFIC',
    },
    {
      label: 'SPREAD',
      value: 'SPREAD',
    },
    {
      label: 'SPREAD_CARRY',
      value: 'SPREAD_CARRY',
    },
    {
      label: 'SPREAD_EMPIRICAL',
      value: 'SPREAD_EMPIRICAL',
    },
    {
      label: 'SPREAD_MARKET',
      value: 'SPREAD_MARKET',
    },
    {
      label: 'SPREAD_OTHER',
      value: 'SPREAD_OTHER',
    },
    {
      label: 'YIELD',
      value: 'YIELD',
    },
    {
      label: 'OTHER',
      value: 'OTHER',
    },
  ],
};

export default produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      const { definition, idx } = action;
      const selectedDefinitions = state.definitions[SelectionState.UNCOMMITTED];
      if (definition === null) {
        selectedDefinitions.splice(idx, 1);
      } else {
        selectedDefinitions[idx] = definition;
      }
      break;
    }
    case DELETE_DEFINITION:
      state.definitions = deleteDefinition(state.definitions, action.payload);
      break;
    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }
    case COMMIT_SELECTIONS: {
      state.data = defaultState.data;
      state.definitions[SelectionState.COMMITTED] = state.definitions[SelectionState.UNCOMMITTED];
      break;
    }
    case REQUEST_GRID_DATA: {
      state.fetchingData[action.summary] = true;
      state.data[action.summary] = defaultState.data[action.summary];
      break;
    }
    case RECEIVE_GRID_DATA: {
      state.fetchingData[action.summary] = false;
      state.data[action.summary] = action.data;
      break;
    }
    case REQUEST_ANALYTICS_SBS_DATA: {
      state.fetchingTESbsData[action.summary] = true;
      state.trackingSbsData[action.summary] =
        defaultState.trackingSbsData[action.summary];
      break;
    }
    case RECEIVE_ANALYTICS_SBS_DATA: {
      state.fetchingTESbsData[action.summary] = false;
      state.trackingSbsData[action.summary] = action.data;
      break;
    }
    default:
      return state;
  }
});
